<template>

  <div v-if="editMode || filled">
    <div class="card-header">
      <i
        class="fas fa-pencil-alt"
        :title="$t('Edit')"
        v-if="!editable && editMode"
        @click.stop="editSection(true)"
        style="cursor: pointer; float: right;">
        </i>
      <strong>{{ $t('Contacts') }}</strong>
    </div>
    <div
      v-if="editable"
      class="card-body">
      <form v-on:submit.prevent="save(candidateEdit)">

        <div class="form-group">
          <label>{{ $t('Email') }}</label>
          <input
            v-autofocus
            class="form-control"
            type="text"
            v-model="candidateEdit.email"
            :placeholder="$t('Email')">
          <ValidateMessage :error="validateErrors.email" />
        </div>

        <div class="form-group">
          <label>{{ $t('Phones') }}</label>
          <div>
            <div 
              v-for="(item, index) in candidateEdit.phones"
              :key="index"
              class="mb-1">
              <div class="input-group">
                <input
                  class="form-control"
                  type="text"
                  v-model="candidateEdit.phones[index]">
                <div class="input-group-append">
                  <button
                    class="btn btn-outline-secondary"
                    type="button"
                    @click="removePhone(index)">
                    {{ $t('Remove') }}
                    </button>
                </div>
              </div>
              <ValidateMessage :error="validateErrors['phones.'+index]" />
            </div>
          </div>
          <a href="javascript:void(0)" @click="addPhone()">{{ $t('Add phone') }}</a>
        </div>
        
        <div :class="{'box-loading': loading}">
          <button
            type="submit"
            class="btn btn-primary">
            {{ $t('Save') }}
            </button>
          <button
            type="button"
            class="btn btn-light" 
            @click.stop="editSection(false)">
            {{ $t('Cancel') }}
            </button>
        </div>
      </form>
    </div>
    <div
      v-if="!editable"
      class="card-body">
      
      <div
        v-if="editMode || candidate.email"
        class="row mb-2">
        <div class="col-sm-3">
          <strong>{{ $t('Email') }}</strong>
        </div>
        <div class="col-sm-8">
          {{ candidate.email || '--' }}
        </div>
      </div>

      <div
        v-if="editMode || (candidate.phones && candidate.phones.length)"
        class="row mb-2">
        <div class="col-sm-3">
          <strong>{{ $t('Phones') }}</strong>
        </div>
        <div class="col-sm-8">
          <div
            v-if="candidate.phones && candidate.phones.length"
            class="phone-list">
            <div
              v-for="(phone, index) in candidate.phones"
              :key="index"
              class="btn-group" role="group">
              <button
                type="button"
                class="btn btn-light dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
                {{ phone }}
                </button>
              <div
                class="dropdown-menu">
                <button
                  type="button"
                  class="dropdown-item"
                  @click="openWhatsapp(phone)">
                  <i class="fa fa-whatsapp" />
                  {{ $t('Open with WhatsApp') }}
                  </button>
                <button
                  type="button"
                  class="dropdown-item"
                  @click="openPhone(phone)">
                  <i class="fas fa-phone-alt" />
                  {{ $t('Call') }}
                  </button>
                <button
                  type="button"
                  class="dropdown-item"
                  @click="copy(phone)">
                  <i class="fa fa-copy" />
                  {{ $t('Copy number') }}
                  </button>
              </div>
            </div>
          </div>
          <span v-if="!(candidate.phones && candidate.phones.length)">--</span>
        </div>
      </div>
      
    </div>
  </div>

</template>

<script>
import copy from 'copy-to-clipboard'

export default {
  name: 'CandidateProfileContacts',
  components: {
  },
  props: [
    'editMode'
  ],
  data () {
    return {
      loading: false,
      sectionEdit: false,
      candidateEdit: {},
      validateErrors: false
    }
  },
  created () {
  },
  computed: {
    editable () {
      return this.sectionEdit && this.editMode
    },
    candidate () {
      return this.$store.getters.getCandidate
    },
    resources () {
      return this.$store.getters.getResources
    },
    filled () {
      return this.candidate.email || (this.candidate.phones && this.candidate.phones.length)
    }
  },
  methods: {
    editSection (status) {
      this.sectionEdit = status
      this.candidateEdit = {
        _id: this.candidate._id,
        phones: Array.isArray(this.candidate.phones) ? this.candidate.phones : [],
        email: this.candidate.email
      }
    },
    save (data) {
      this.loading = true

      this.$store.dispatch('updateCandidate', data)
      .then((response) => {
        this.loading = false
        this.sectionEdit = false
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    addPhone () {
      this.candidateEdit.phones.push('')
    },
    removePhone (index) {
      this.candidateEdit.phones.splice(index, 1)
    },
    openWhatsapp (phone) {
      window.open(`https://api.whatsapp.com/send?phone=${phone.replace(/[^0-9]/g, '')}`)
    },
    openPhone (phone) {
      window.location.href = `tel:${phone.replace(/[^0-9]/g, '')}`
    },
    copy (phone) {
      copy(phone)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.phone-list > * {
  margin: 0 5px 5px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Candidate/Profile/CandidateProfileContacts.vue